import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Ticket } from 'lucide-react';
import { toast } from 'sonner';
import { api, errText } from '@/lib/api';
import { Button } from '@/components/ui/button';

const ACTIVE = ['open', 'in_progress'];

export function TicketButton({ conv, canAct, onDone }) {
  const [busy, setBusy] = useState(false);
  const t = conv.ticket;
  const create = async () => {
    setBusy(true);
    try {
      const { data } = await api.post(`/whatsapp/conversations/${conv.id}/ticket`);
      if (data.existing) toast.info(`Ya existe el ticket ${data.number} para esta conversación`);
      else toast.success(`Ticket ${data.number} creado${data.notice_error ? '' : ' y usuario avisado por WhatsApp'}`);
      onDone();
    } catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  if (t && ACTIVE.includes(t.status)) {
    return (
      <Button asChild size="sm" variant="outline" className="border-emerald-500/40 text-emerald-300">
        <Link to={`/app-tickets?wa_ticket=${t.id}`} data-testid="whatsapp-ticket-link"><Ticket className="h-4 w-4 mr-1" />Ticket {t.number}</Link>
      </Button>
    );
  }
  if (!canAct) return null;
  return (
    <Button size="sm" variant="outline" onClick={create} disabled={busy} data-testid="whatsapp-create-ticket-button">
      <Ticket className="h-4 w-4 mr-1" />{busy ? 'Creando ticket…' : 'Crear ticket'}
    </Button>
  );
}
